import { GetStaticProps } from 'next'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../next-i18next.config";

import {getAllWhitepaper} from "../lib/api";
import Layout from "../components/layout";
import Link from "next/link";
import CallToActionBlogBottom from "../components/v2/call-to-action-blog-bottom";
import parse from "html-react-parser";
import dayjs from "dayjs";
import BlogHeroSectionV2 from "../components/v2/blog/blog-hero";
import SearchBlog from "../components/v2/blog/search-blog";
import CardWithIcon from "../components/v2/cards/card-with-icon";
import {CustomerStoryHexa, EventHexa, ProductUpdateHexa, WhitepaperHexa} from "../components/v2/icons";
import "../styles/scss/blog.module.scss";
import "../styles/scss/resources.module.scss";

export default function Whitepaper({allWhitepaper}) {

    const heroPost = [allWhitepaper.edges[0]];
    const belowPost = allWhitepaper.edges.slice(1);

    return (
        <Layout
            isHomePage={false}
            pageTitle={'Observability Guides & Whitepaper'}
            ogImage={"/images/resources/whitepaper-page-og.png"}
            metaTitle={'Observability Guides & Whitepaper'}
            metaDesc={'Read in-depth guides, whitepapers, ebooks and webinars on observability and monitoring from our experts.'}
            uri={'/whitepaper/'}
            metaRobotsNoindex={"index"}
            metaRobotsNofollow={"follow"}
        >
            <div className={'middle-wrapper site-page whitepaper-main blog-v2'}>
                <div className={"whitepaper-hero-section blog-hero"}>
                    <div className={"whitepaper-search header-section"}>
                        <div className={"container"}>
                            <div className={"d-flex"}>
                                <div className={"left-block"}>
                                    <h1><span className={"text-gradient"}>Whitepaper</span> and <span className={"text-gradient"}>Ebooks</span></h1>
                                    <p>Explore various resources, including whitepapers and eBooks, on observability and monitoring.</p>
                                </div>
                                <div className={"right-block"}>
                                    <SearchBlog searchInputPostDetails={belowPost} parentSlug={"whitepaper"} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <BlogHeroSectionV2
                        leftBlockPostDetails={heroPost}
                        isCategories={true}
                    />
                </div>



                <section className={"all-blogs-show see-all-whitepaper all-blogs-v2"}>
                    <div className={'container'}>
                        <div className={'content-container'}>
                            <div className={'content-wrapper'}>
                                <div className={'d-flex'}>
                                    {belowPost.map(__post => {
                                        const post = __post.node
                                        const title = post.title
                                        return <div className={'inner-block'} key={post.uri}>
                                            <Link href={`/whitepaper/${post.slug}`} itemProp="url"> <div className={'image-wrapper'}>
                                                <img src={post?.featuredImage?.node?.sourceUrl} alt={title} />
                                            </div></Link>
                                            <div>
                                                <div key={post.uri}>
                                                    <article
                                                        className="post-list-item"
                                                        itemScope
                                                        itemType="http://schema.org/Article"
                                                    >
                                                        <header>
                                                            <Link href={`/whitepaper/${post.slug}`} itemProp="url"><h4>

                                                                {parse(title)}

                                                            </h4></Link>
                                                            <div className={"date-time"}>{dayjs(post?.date).format("D MMM YYYY")}</div>
                                                        </header>
                                                    </article>
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className={"mw-card-with-icon blog-page"}>
                    <div className={"container"}>
                        <div className={"card-items"}>
                            <div className={"d-flex card-items"}>
                                <CardWithIcon
                                    icon={<EventHexa />}
                                    title={"Events"}
                                    description={
                                        "Stay updated on Middleware's upcoming events, meetups, and industry gatherings."
                                    }
                                    link={"/events/"}
                                />
                                <CardWithIcon
                                    icon={<CustomerStoryHexa />}
                                    title={"Customer Stories"}
                                    description={
                                        "Expert Insights and Solutions: Your Guide to Smarter Decisions."
                                    }
                                    link={"/customers/"}
                                />
                                <CardWithIcon
                                    icon={<ProductUpdateHexa />}
                                    title={"Product Update"}
                                    description={
                                        "Latest Innovations and Enhancements: Your Guide to Product Excellence."
                                    }
                                    link={"/product-updates/"}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <CallToActionBlogBottom img={"/images/resources/middleware-resource-team.png"}/>
            </div>
        </Layout>
    )
}

export const getStaticProps: GetStaticProps = async ({ preview = false, locale }) => {
    const allWhitepaper = await getAllWhitepaper()

    return {
        props: {
            allWhitepaper, preview,
            pageTitle: 'Observability Whitepaper | Middleware',
            ogImage: "/images/resources/whitepaper-page-og.png",
            metaTitle: 'Observability Whitepaper | Middleware',
            metaDesc: 'Browse Middleware\'s resource library for in-depth guides, whitepapers, and webinars to enhance your skills and stay ahead.',
            description: 'Browse Middleware\'s resource library for in-depth guides, whitepapers, and webinars to enhance your skills and stay ahead.',
            uri: '/whitepaper/',
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
            ...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer'], nextI18NextConfig)),
        },
    }
}
